import { render, staticRenderFns } from "./MesesAnos.vue?vue&type=template&id=add844a2&scoped=true&"
import script from "./MesesAnos.vue?vue&type=script&lang=js&"
export * from "./MesesAnos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "add844a2",
  null
  
)

export default component.exports